import React, {useEffect, useState} from 'react';
import {StyledCarousel} from "./AdsBanner.styled";
import {connect} from "react-redux";
import {getProductProperties} from "../../../features/adInsert/actions/AdInsert.action";
import {withRouter} from "../../../utils/services/with-router";
import {getBanner} from "../../actions";
import {AdsBannerProps} from "../../models";
import {useNavigate} from "react-router-dom";

const contentStyle: React.CSSProperties = {
    height: '100px',
    width: '100%',
    color: '#fff',
    lineHeight: '100px',
    textAlign: 'center',
    borderRadius: '10px',
};

const AdsBanner = ({getBanner ,marginTop} : AdsBannerProps) => {
    const [banners, setBanners] = useState<any[]>([])
    const BaseURL = process.env.REACT_APP_IMAGES_URL;
    const navigate = useNavigate();
    const _getBanner = () => {
        let model ={

        }
        getBanner(model)
            .then((data: any) => {
                if (data.payload != undefined) {
                    let tempData = data.payload.data.map((item:any,index:any) => ({
                        id : item.id,
                    }))
                    setBanners(data.payload.data)

                } else {
                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        _getBanner();
    }, []);

    return (
        banners?.length > 0 &&
         <StyledCarousel autoplay style={{marginTop:marginTop}}>
        {banners?.map((i: any) => <div onClick={() => navigate( i?.link )}>
            <img style={contentStyle} alt={i?.imageURL} loading={"lazy"} src={`${BaseURL}/${i?.imageURL}`}/>
        </div>)}

      </StyledCarousel>

    );
};

export default connect(null, {getBanner})(withRouter(AdsBanner));
